module.exports = __webpack_public_path__ + "static/media/15_tn.f2f26b4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/15_tn.jpg
// module id = 445
// module chunks = 0